import React from 'react';
import {Link} from 'react-router-dom';
import WorkoutsDisplay from '../../components/workoutsDisplay';
import homeStyle from './style';
import FoldPage from './foldPage/index';
import AreYouReady from './areYouReadySection/index';
import YGAP from './YGAP/index';
import DWT from './DWT/index';
import DisplaySection from './displaySection/index';

export default function Home() {
	let style = homeStyle();
	return (
		<div style={style.outerStyle()}>
			<FoldPage />
			<AreYouReady />
			<YGAP />
			<DWT />
			<DisplaySection />
		</div>
	);
}
